import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import * as actions from '../actions';
import { Icon, Popover, Button, Spin, Modal } from 'antd';

import Searchbar from './search/Searchbar';
import { isEmpty } from '../util/isEmpty';
import NoResult from './NoResult';
import StartCard from './StartCard';
import Toast from './common/Toast';

import MainResultCardComponent from './result-section/main-result-component/MainResultCardComponent';
import PriceHeaderTab from './result-section/priceHeader/PriceHeaderTab';
import RfqResultsBanner from './result-section/RfqResultsBanner';
import DiscountBanner from './result-section/DiscountBanner';
import ContactForm from './result-section/contactForm/ContactForm';
import SideComponent from './result-section/sideComponents/SideComponent';

import FormContainerModal from './form-section/FormContainerModal';
import CustomMessage from './result-section/customMessage/CustomMessage';
import OverlayFullScreenModal from './common/OverlayFullScreenModal';
import ErrorBoundary from '../ErrorBoundary';
import { SearchingSpinner } from './result-section/main-result-component/SearchingSpinner';
import { totalCards } from '../util/totalCards';
import { checkParentOrigins } from '../util/checkParentOrigins';
import { isDevENV } from '../util/isDevENV';
import { shouldGateResults } from '../util/shouldGateResults';
// One-page public booking (rate-gate P2): replaces the 3-tab
// CustomerExecuteShipmentTabs for public users. The legacy tab components stay
// in the tree — SignUp (credit app) + BookViaAgent mount as post-booking
// follow-ups inside ConfirmAndBook's success screen.
import ConfirmAndBook from './booking/confirm/ConfirmAndBook';
import BookingConfirmation from './form-section/BookingConfirmation';

// Lazy-loaded (#75 c8): the booking review is the REAL prod FInalView (broker
// dropdown, rate/route summary, PO, insurance, duty — kept, not replaced). It
// statically imports the actions barrel, so eager-importing during Home's
// bootstrap eval triggers a circular-dependency failure; deferring eval to
// render time — after Book Now — sidesteps the cycle.
const FInalView = React.lazy(() => import('./form-section/FInalView'));

const StyledSpin = styled(Spin)`
  &&.ant-spin .ant-spin-dot-item {
    /* background: ${(props) => props.secondaryColor}; */
  }
`;

/**
 * @component
 * @name Home
 * @category Search Page
 * @description It the common container component for both Search and Form page
 * <br> <br>
 * **Example**
 * ```js
 *   <Home/>
 * ```
 */
class Home extends Component {
  state = {
    width: 1199,
  };

  componentWillMount = () => {
    const isLandingPageExist =
      [this.props.location.pathname].filter((o) => o.includes('/landing-page'))
        .length !== 0;

    //don't do data polling byuuid if on landing page
    const dataPolling = !isLandingPageExist;
    // console.log('Home dataPolling?: ', dataPolling);

    this.props.setDataPolling(dataPolling, () => {
   this.props.getInitAuth(this.getRemoteData);
    });
    this.props.getRemotePortsJson();


      window.addEventListener('resize', this.handleWindowSizeChange);

      window.addEventListener('message', this.receiveScrollMessage, false);

  };

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll, false);
    window.removeEventListener('resize', this.handleWindowSizeChange);
    window.removeEventListener('message', this.receiveMessage);
  }

  /**
   * @description It is invoked when window size is changed
   * <br> <br>
   * **handleWindowSizeChange() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  /**
   * @description It is invoked when user scrolls
   * <br> <br>
   * **handleScroll(event) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | event         | Event         | Mouse event  |
   * <br> <br>
   * Returns: Type: void
   */
  handleScroll = (event) => {
    // const scrollTop = window.scrollY;
    const scrollTop = event.srcElement.scrollTop;

    //to do- update only if previos scroll has been reached more than certaimn height
    // this.props.saveCodeSettings({ scrollTop });

    // console.log(event);
    const { width } = this.state;
    if (width < 992) {
      return;
    }

    const minHeight = 76;
    let searchbarHeight = Math.max(minHeight, 116 - scrollTop);

    if (width < 992) {
      searchbarHeight = 116;
      // searchbarHeight = 216;
    }

    if (this.props.searchbarHeight !== searchbarHeight) {
      this.props.saveCodeSettings({ searchbarHeight });
      // console.log('NOT equal searchbarHeight: ', this.props.searchbarHeight);
    }
  };

  /**
   * @description it's for fetching initial json results based on query params
   * <br> <br>
   * **getRemoteData() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  getRemoteData = () => {
    //if form is showing then don't fetch remote data
    if (this.props.showForm) {
      return ;
    }
    let url = window.location.href;
    // console.log('home page url: ', url);
    this.props.getJSON(url, () => {
      // return console.log("home.js url: ", this.props.url)
    });
  };

  /**
   * @description It is for getting scroll position from parent website
   * <br> <br>
   * **receiveScrollMessage(event) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | event         | Event         | Message event  |
   * <br> <br>
   * Returns: Type: void
   */
  //{type:"SCROLL_POSITION", payload: 10}
  receiveScrollMessage = (event) => {
    if (!checkParentOrigins(event.origin)) {
      return;
    }

    console.log('message received from parent!, event: ', event);

    if (event.data.type === 'SCROLL_POSITION') {
      let scrollPosition = Number(event.data.payload);
      scrollPosition = isNaN(scrollPosition) ? 0 : scrollPosition;

      this.props.updateParentScrollbarPosition(scrollPosition);
    }
  };

  render() {
    const {
      seaFCLJSON,
      seaLCLJSON,
      airJSON,
      showNoResultCard,
      showSearchContactForm,
      initAuth,
      newRatesLoading,
      searchCustomMsgJSON,
      newRatesRemainingTime,
      showNewRateContactForm,
      showOverlayFullScreen,
      overlayProgress,
      userEmailBlurCards,
      final_view_after_submit,
      final_view_after_booking,
      enableSearchBlurCards,
    } = this.props;
    const { showForm } = this.props;

    const spinner = this.props.loading && (
      <StyledSpin
        size="large"
        className="spinner"
        style={{}}
        // secondaryColor={this.props.secondaryColor}
      />
    );

    const { user, verification } = initAuth;

    const isUserPresent = !!(user && verification);

    // console.log('isUserPresent', isUserPresent, user, verification);

    // console.log({ newRatesRemainingTime });

    // Whether results are gated (blur-card unlock). Use the SAME gate as
    // MainResultCardComponent so the lead-capture ContactForm never leaks
    // through for public visitors who are being shown the rate-gate first.
    let showResultBlurCards = shouldGateResults(
      seaFCLJSON,
      seaLCLJSON,
      airJSON,
      initAuth,
      enableSearchBlurCards
    );

    return (
      <div 
      // style={{ background: '#ECECEC' }}
      >
        <ErrorBoundary>
          {/* show overlay full screen modal here */}
          {showOverlayFullScreen && (
            <OverlayFullScreenModal
              showModal={showOverlayFullScreen}
              progressOverride={overlayProgress}
            />
          )}
{/* 
          <Scrollbars
            autoHeight={true}
            autoHeightMin={window.innerHeight}
            // maybe remove it, because height will be
            //set (in parent website, not in this site) according to content,
            //so it won't appear at all
            renderTrackVertical={(props) => (
              <div
                {...props}
                style={{
                  display: 'none',
                }}
                // className="track-vertical"
              />
            )}
            onScroll={this.handleScroll}
          > */}
            <div>
              {/* spinner */}
              {spinner}
              {/* react toast message */}
              {this.props.errorMessage.trim() !== '' ? <Toast /> : null}
              {showForm ? (
                  <FormContainerModal />
              ) : (
                this.props.public_user_view_after_submit ?
                <div style={{backgroundColor:'#FFF', minHeight: '100vh'}}>
                  <ConfirmAndBook />
                </div>
                :
                <div className="root-container">
                  {/* Top search bar */}
                  <div
                    // className="home-search-container"
                    style={{
                      //height: `${this.props.searchbarHeight}px`,
                      background: this.props.primaryColor,
                      position:"relative",
                      padding: "0.7rem",
                    }}
                  >
                    {/*Header component,Search bar */}
                    {/* Main Searchbar Container*/}
                    <Searchbar />
                  </div>
                  {/* result cards */}

                  <div>
                    {/* Logged-in booking flow (#75 c8/c9): Book Now -> the REAL prod
                        FInalView booking review -> confirmation. Home is the active
                        results container, so the gate lives here (search_component has
                        the same gate but isn't the mounted container). FInalView is made
                        to render offline (guarded + seeded fixtures); the c9 RFQ controls
                        ride on its existing insurance/customs sections. */}
                    {final_view_after_booking && final_view_after_booking.bookingSuccessful ? (
                      <BookingConfirmation
                        bookingId={final_view_after_booking.bookingId}
                        rfq={final_view_after_booking.rfq}
                      />
                    ) : final_view_after_submit ? (
                      <React.Suspense fallback={<div style={{ padding: 40 }}>Loading…</div>}>
                        <FInalView />
                      </React.Suspense>
                    ) : showNoResultCard ? (
                      <NoResult
                        showSearchContactForm={showSearchContactForm}
                        isUserPresent={isUserPresent}
                      />
                    ) : (
                      <>
                        <div className="home-result-container-new testBlu1">
                          <div
                            style={{
                              marginTop: '15px',
                              display: 'flex',
                            }}
                            className="home-result-parent testR1"
                          >
                            <div
                              className="home-result-side-component testR1"
                              style={{
                                order: 1,
                               // marginRight: '20px',
                               // marginTop: '55px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                              }}
                            >
                              {(!isEmpty(seaFCLJSON) ||
                                !isEmpty(seaLCLJSON) ||
                                !isEmpty(airJSON)) && (
                                <div
                                  style={{
                                    maxWidth: '675px',
                                    width: '100%',
                                  }}
                                >
                                  <SideComponent />
                                </div>
                              )}
                            </div>

                            <div
                              style={{
                                order: 2,
                                marginTop: '0px',
                                maxWidth: '675px',
                                width: '100%',
                              }}
                            >
                              {(!isEmpty(seaFCLJSON) ||
                                !isEmpty(seaLCLJSON) ||
                                !isEmpty(airJSON)) && (
                                <div className="testR1">
                                  {/* sorting radio btns */}
                                  <PriceHeaderTab />

                                  {/* standalone "Request RFQ" entry point.
                                      Wrapped in a div on purpose: as a bare
                                      prop-less element adjacent to <PriceHeaderTab/>,
                                      the production build's constant-element
                                      optimizer silently drops it. The wrapper
                                      keeps it from being hoisted/eliminated. */}
                                  <div className="rfq-results-banner-row">
                                    <RfqResultsBanner />
                                  </div>

                                  {/* Rate-gate discount banner (unlock grant).
                                      Wrapped in a div for the same reason as the
                                      RFQ banner above: the production build's
                                      constant-element optimizer drops bare
                                      adjacent prop-less elements. */}
                                  <div className="discount-banner-row">
                                    <DiscountBanner />
                                  </div>

                                  {/* searching spinner for uuid requests below sorting radio btns*/}
                                  {newRatesLoading && (
                                    <SearchingSpinner
                                      remainingTime={newRatesRemainingTime}
                                      style={{
                                        marginBottom: '15px',
                                        // hide it if total cards is below 2
                                        ...(totalCards(
                                          seaFCLJSON,
                                          seaLCLJSON,
                                          airJSON
                                        ) < 2 && { display: 'none' }),
                                      }}
                                    />
                                  )}

                                  {/* Public visitors already gave their email
                                      at the blur-card unlock, so we never
                                      re-capture the lead here. Only signed-in
                                      users get the ContactForm, where it renders
                                      the "Create RFQ" CTA (not a name/email
                                      form) when new rates return nothing. */}
                                  {!showResultBlurCards &&
                                    isUserPresent &&
                                    showNewRateContactForm && <ContactForm />}

                                  {/* Custom Message */}
                                  {!searchCustomMsgJSON ||
                                    (!isEmpty(searchCustomMsgJSON) && (
                                      <CustomMessage />
                                    ))}

                                  {/* result cards */}
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      // justifyContent: "center",
                                      alignItems: 'center',
                                    }}
                                    className="testBla1"
                                  >
                                    <MainResultCardComponent />
                                  </div>
                                </div>
                              )}
                              {/* searching spinner for uuid requests below rate cards*/}
                              {newRatesLoading && (
                                <SearchingSpinner
                                  remainingTime={newRatesRemainingTime}
                                />
                              )}
                            </div>
                          </div>
                          {/* When app loads for first time show this big card*/}
                          {/* {airJSON === null &&
                            seaFCLJSON === null &&
                            seaLCLJSON === null && <StartCard />} */}
                        </div>
                        {airJSON === null &&
                            seaFCLJSON === null &&
                            seaLCLJSON === null && <StartCard />}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          {/* </Scrollbars> */}
        </ErrorBoundary>
      </div>
    );
  }
}

Home.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,

  /**
   * in-app error message notify, shown at bottom-right in case of network error, server error, etc.
   */
  errorMessage: PropTypes.string,
  /**
   * should show a loading spinner
   */
  loading: PropTypes.bool,
  /**
   * url (it has relevant params) so that it can be used in browser address field
   */
  url: PropTypes.string,

  /**
   * whether to show contact form
   */
  showSearchContactForm: PropTypes.bool,
  /**
   * whether to show [No Result]{@link NoResult} card
   */
  showNoResultCard: PropTypes.bool,

  /**
   * height of top [search bar]{@link Searchbar} section in px
   */
  searchbarHeight: PropTypes.number,

  /**
   * primary color of web app
   */
  primaryColor: PropTypes.string,
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
  /**
   * initial authentication info
   */
  initAuth: PropTypes.object,
  /**
   * whether search results are gated behind the blur-card unlock
   */
  enableSearchBlurCards: PropTypes.bool,
  /**
   * whether to show map beside view-details section
   */
  showOpenMap: PropTypes.bool,
  /**
   * Whether to show Form modal i.e Form page
   */
  showForm: PropTypes.bool,
  /**
   * whether to show searching spinner for uuid requests below sorting radio button and below rate cards
   */
  newRatesLoading: PropTypes.bool,
  /**
   * whether to disable capability of data polling (api request) by uuid on landing page
   */
  dataPolling: PropTypes.bool,
  /**
   * [custom message]{@link CustomMessage} is shown on top of results cards on search page
   */
  searchCustomMsgJSON: PropTypes.object,
  /**
   * remaining time of new rates of UUID request e.g. `1 min 12 sec`
   */
  newRatesRemainingTime: PropTypes.string,
  /**
   *  whether to show contact form above result cards on search page
   */
  showNewRateContactForm: PropTypes.bool,
  /**
   * whether to show full screen Overlay
   */
  showOverlayFullScreen: PropTypes.bool,
  /**
   * overlay progress percentage
   */
  overlayProgress: PropTypes.number,
  /**
   * email address of user for blur cards
   */
  userEmailBlurCards: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    seaFCLJSON: state.route.seaFCLJSON,
    seaLCLJSON: state.route.seaLCLJSON,
    airJSON: state.route.airJSON,

    errorMessage: state.route.errorMessage,
    loading: state.route.loading,
    url: state.route.url,
    final_view_after_submit:state.form.final_view_after_submit,
    final_view_after_booking: state.form.final_view_after_booking,
    showSearchContactForm: state.route.showSearchContactForm,
    showNoResultCard: state.code_config.showNoResultCard,
    searchbarHeight: state.code_config.searchbarHeight,

    primaryColor: state.code_config.primaryColor,
    secondaryColor: state.code_config.secondaryColor,
    initAuth: state.code_config.initAuth,
    enableSearchBlurCards: state.code_config.enableSearchBlurCards,

    showOpenMap: state.code_config.showOpenMap,
    showForm: state.form.showForm,
    newRatesLoading: state.route.originalRateData.loading,

    dataPolling: state.code_config.dataPolling,
    searchCustomMsgJSON: state.code_config.searchCustomMsgJSON,
    newRatesRemainingTime: state.route.newRatesRemainingTime,

    showNewRateContactForm: state.route.showNewRateContactForm,
    showOverlayFullScreen: state.code_config.showOverlayFullScreen,
    overlayProgress: state.code_config.overlayProgress,
    userEmailBlurCards: state.cache.userEmailBlurCards,
    isFormSubmitSuccess: state.form.isFormSubmitSuccess,
    public_user_view_after_submit: state.form.public_user_view_after_submit,
  };
};

export default connect(mapStateToProps, actions)(Home);
